









































































































































































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import TandaVital from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/TandaVital.vue";
import Antropometri from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/Antropometri.vue";
import Fungsional from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/Fungsional.vue";
import Keluhan from "@/components/pemeriksaan/assesmen/Keluhan.vue";
import RiwayatPenyakit from "@/components/pemeriksaan/assesmen/RiwayatPenyakit.vue";
import Mual from "@/components/pemeriksaan/assesmen/Mual.vue";
import Muntah from "@/components/pemeriksaan/assesmen/Muntah.vue";
import StatusPsikologi from "@/components/pemeriksaan/assesmen/StatusPsikologi.vue";
import Alergi from "@/components/pemeriksaan/assesmen/Alergi.vue";
import HambatanBudaya from "@/components/pemeriksaan/assesmen/HambatanBudaya.vue";
import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { storeSoap } from "@/store/modules/soap";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import InterfaceAsesmenRalan from "@/apiInterface/InterfaceAsesmenRalan";
import PrefillMixin from "@/mixins/PrefillMixin";

@Component({
  components: {
    TandaVital,
    Antropometri,
    PerawatAutoComplete,
    Fungsional,
    Keluhan,
    RiwayatPenyakit,
    Mual,
    Muntah,
    StatusPsikologi,
    Alergi,
    HambatanBudaya,
    // CardModalSoap,
    ModalKonfirmasi
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAssesmenPerawat extends Mixins(PrefillMixin) {
  @Prop() register!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  sess_login = userModule.user;
  getparam = {
    reg: this.register,
    unit_id: this.sess_login.unit_id
  };
  diagnosisPerawat = "";
  tindakanPerawat = "";
  mual = null;
  muntah = null;
  // asesmenAwal = {};
  anamnesis = {
    keluhan: null,
    riwayat_penyakit: null,
    status_psikologis_id: null,
    status_psikologis_text: "",
    hambatan: this.statePasien ? this.statePasien["hambatan_budaya"] : null,
    alergi: this.statePasien ? this.statePasien.alergi : null
  };
  tandaVital = {
    sistole: null,
    diastole: null,
    frekuensi_nadi: null,
    frekuensi_nafas: null,
    suhu_badan: null,
    saturasi_oksigen: null,
    keadaan_umum: "",
    kesadaran: ""
  };
  antropometri = {
    berat_badan: null,
    tinggi_badan: null,
    imt: null,
    lingkar_kepala: null,
    lla: null
  };
  fungsional = {
    alat_bantu: null,
    prothesa: null,
    cacat_tubuh: null,
    adl: null
  };
  risikoJatuh = null;
  riwayatPerawatan = "";
  nyeri = {
    skala: 0,
    lokasi: "",
    // intensitas: null,
    durasi: null,
    frekuensi: null,
    pencetus: "",
    kualitas: "",
    pola_serangan: "",
    penyebab_hilang: "",
    jenis: "0"
  };
  hambatan = this.statePasien ? this.statePasien["hambatan_budaya"] : null;
  labelDiag = "";
  labelRen = "";
  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 8);
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  modalSoap = false;
  alergi = this.statePasien ? this.statePasien.alergi : null;
  perawat = {};
  modalOpenKonfirmasi = false;
  loadingSimpan = false;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  prefillFormKey = "asesmen_awal_ralan";

  /**
   * Translate server-side prefill paths to this component's reactive props.
   * Keys must match AsesmenAwalRalanPrefillResolver::PATH_MAP values.
   */
  prefillResolvePath(path: string) {
    switch (path) {
      case "alergi":
        return { get: () => this.alergi, set: (v: any) => { this.alergi = v; } };
      case "hambatan_budaya":
        return { get: () => this.hambatan, set: (v: any) => { this.hambatan = v; } };
      case "riwayat_perawatan_sebelum":
        return {
          get: () => this.riwayatPerawatan,
          set: (v: any) => { this.riwayatPerawatan = v; }
        };
      case "tanda_vital.sistole":
      case "tanda_vital.diastole":
      case "tanda_vital.frekuensi_nadi":
      case "tanda_vital.frekuensi_nafas":
      case "tanda_vital.suhu_badan":
      case "tanda_vital.saturasi_oksigen":
      case "tanda_vital.keadaan_umum":
      case "tanda_vital.kesadaran": {
        const k = path.split(".")[1];
        return {
          get: () => this.tandaVital[k],
          set: (v: any) => {
            this.tandaVital = { ...this.tandaVital, [k]: v };
          }
        };
      }
      case "antropometri.tinggi_badan":
      case "antropometri.berat_badan":
      case "antropometri.lingkar_kepala":
      case "antropometri.lla": {
        const k = path.split(".")[1];
        return {
          get: () => this.antropometri[k],
          set: (v: any) => {
            this.antropometri = { ...this.antropometri, [k]: v };
          }
        };
      }
      case "fungsional.alat_bantu":
      case "fungsional.prothesa":
      case "fungsional.cacat_tubuh": {
        const k = path.split(".")[1];
        return {
          get: () => this.fungsional[k],
          set: (v: any) => {
            this.fungsional = { ...this.fungsional, [k]: v };
          }
        };
      }
      default:
        // Unknown path: pretend the field is already filled so the mixin
        // skips it and never records misleading provenance.
        return { get: () => "__skip__", set: () => undefined };
    }
  }

  mounted() {
    if (this.sess_login.profesi == "Dokter") {
      this.perawat = {};
    } else {
      this.perawat = {
        id: this.sess_login.id,
        nama: this.sess_login.nama
      };
    }
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }
  get statePasien() {
    return storePasien.identitasPasien;
  }
  get statesoap() {
    return storeSoap.soapAllPerawat;
  }
  setPerawat(val) {
    this.perawat = val;
  }
  setRisikoJatuh(v) {
    this.risikoJatuh = v;
  }
  setKeluhan(v) {
    this.anamnesis["keluhan"] = v;
  }
  setMual(v) {
    this.mual = v;
  }
  setMuntah(v) {
    this.muntah = v;
    console.log("mmm", v);
  }
  setRiwayatPenyakit(v) {
    this.riwayatPerawatan = v;
  }
  setHambatanBudaya(v) {
    this.hambatan = v;
  }
  setAlergi(v) {
    this.alergi = v;
    // this.anamnesis["alergi"] = v;
  }
  setStsPsikologiId(v) {
    this.anamnesis["status_psikologis_id"] = v;
  }
  setStsPsikologiText(v) {
    this.anamnesis["status_psikologis_text"] = v;
  }

  getTandaVital(val) {
    this.tandaVital = val;
  }
  getNyeri(val) {
    this.nyeri = val;
  }
  getFungsional(val) {
    this.fungsional = val;
  }
  getRisikoJatuh(val) {
    this.risikoJatuh = val;
  }
  getAntropometri(val) {
    this.antropometri = val;
  }

  @Watch("tindakanPerawat")
  valTindakan(v) {
    if (!v) {
      this.labelRen = "";
    } else {
      this.labelRen = "Rencana Keperawatan";
    }
  }
  @Watch("diagnosisPerawat")
  valDiagnosis(v) {
    if (!v) {
      this.labelDiag = "";
    } else {
      this.labelDiag = "Diagnosis Keperawatan";
    }
  }

  @Watch("stateAsesmenAwal")
  changedAsesmenAwal(val) {
    if (val == null) {
      this.alergi = this.statePasien ? this.statePasien.alergi : null;
      this.hambatan = this.statePasien
        ? this.statePasien["hambatan_budaya"]
        : null;
      this.riwayatPerawatan = null;
      // Soft-prefill from patient history. Only fills fields that remain
      // empty after the Vuex defaults above — user edits never overwritten.
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: this.rm,
          register_id: this.register,
          unit_id: this.sess_login.unit_id
        });
      });
    } else {
      if (val["anamnesis"]) this.anamnesis = val["anamnesis"];
      if (val["risiko_jatuh"] != null)
        this.risikoJatuh = val["risiko_jatuh"].toString();
      if (val["perawat"]) this.perawat = val["perawat"];
      if (val["antropometri"]) this.antropometri = val["antropometri"];
      if (val["fungsional"]) this.fungsional = val["fungsional"];
      if (val["tanda_vital"]) this.tandaVital = val["tanda_vital"];
      if (val["nyeri"]) this.nyeri = val["nyeri"];

      if (val["mual"] != null) this.mual = val["mual"].toString();
      if (val["muntah"] != null) this.muntah = val["muntah"].toString();

      this.diagnosisPerawat = val["diagnosis_perawat"];
      this.tindakanPerawat = val["tindakan_perawat"];
      // this.mual = val["mual"].toString();
      // this.muntah = val["muntah"].toString();
      this.hambatan = val["hambatan_budaya"];
      this.alergi = val["alergi"];
      this.riwayatPerawatan = val["riwayat_perawatan_sebelum"];
    }
  }

  simpan() {
    // console.log("anam", this.anamnesis);
    // console.log("tv", this.tandaVital);
    // console.log("antro", this.antropometri);
    // console.log("fung", this.fungsional);
    // console.log("jatuh", this.risikoJatuh);
    // console.log("mual", this.mual);
    // console.log("muntah", this.muntah);
    // console.log("riwayat", this.riwayatPerawatan);
    // console.log("hambatan", this.hambatan);
    // console.log("loadingSimpan", this.loadingSimpan);

    this.loadingSimpan = true;
    let dataNyeri = {};
    if (this.nyeri["skala"] == 0) {
      if (this.nyeri["id"] == undefined) {
        dataNyeri = {
          skala: 0,
          lokasi: "",
          // intensitas: null,
          durasi: null,
          frekuensi: null,
          pencetus: "",
          kualitas: "",
          pola_serangan: "",
          penyebab_hilang: "",
          jenis: "0"
        };
      } else {
        dataNyeri = {
          id: this.nyeri["id"],
          skala: 0,
          lokasi: "",
          // intensitas: null,
          durasi: null,
          frekuensi: null,
          pencetus: "",
          kualitas: "",
          pola_serangan: "",
          penyebab_hilang: "",
          jenis: "0"
        };
      }
    } else {
      dataNyeri = this.nyeri;
    }
    // console.log("nyeri", dataNyeri);
    const param = {
      alergi: this.alergi,
      riwayat_perawatan_sebelum: this.riwayatPerawatan,
      diagnosis_perawat: this.diagnosisPerawat,
      tindakan_perawat: this.tindakanPerawat,
      anamnesis: this.anamnesis,
      tanda_vital: this.tandaVital,
      antropometri: this.antropometri,
      risiko_jatuh: this.risikoJatuh,
      fungsional: this.fungsional,
      nyeri: dataNyeri,
      // nyeri: this.nyeri,
      mual: this.mual,
      muntah: this.muntah,
      hambatan: this.hambatan
    };
    // console.log("param", param);

    if (this.stateAsesmenAwal && this.stateAsesmenAwal["id"]) {
      // console.log("paramedit", param);
      const dt = DataAsesmenRalan.editDataAsesmenRalanKeperawatan(
        this.stateAsesmenAwal["id"],
        this.register,
        this.rm,
        this.sess_login.unit_id,
        this.perawat["id"],
        param
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          storePasien.act_pasien(this.rm);
          storeAssesmenRalan.actAsesmenAwal(this.getparam);
          storePemeriksaanFisikRalan.actPemeriksaanFisikRalan(this.getparam);
          appModule.NoticeDelay("Berhasil Update Asesmen Keperawatan");
          if (
            this.statesoap.length == 0 &&
            this.sess_login.profesi != "Dokter"
          ) {
            // this.modalSoap = true;
            this.modalOpenKonfirmasi = true;
          }
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    } else {
      // console.log("paramsave", param);
      const dt = DataAsesmenRalan.saveDataAsesmenRalanKeperawatan(
        this.register,
        this.rm,
        this.sess_login.unit_id,
        this.perawat["id"],
        param
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          storePasien.act_pasien(this.rm);
          storeAssesmenRalan.actAsesmenAwal(this.getparam);
          storePemeriksaanFisikRalan.actPemeriksaanFisikRalan(this.getparam);
          appModule.NoticeDelay("Berhasil Simpan Asesmen Keperawatan");
          if (
            this.statesoap.length == 0 &&
            this.sess_login.profesi != "Dokter"
          ) {
            // this.modalSoap = true;
            this.modalOpenKonfirmasi = true;
          }
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    }
  }

  cetak() {
    // const dt = DataAsesmenRalan.getCetakPdfAsesmenAwalRalan(
    //   this.stateAsesmenAwal["id"]
    // );
    // dt.then((dt) => {
    //   window.open(dt, "_blank");
    // });

    // const routeData =
    //   // http.getAPI() +
    //   "http://10.10.187.6/rme/public/api/v1" +
    //   "/asesmen-awal-ralan/" +
    //   this.stateAsesmenAwal["id"] +
    //   "/pdf";
    // window.open(routeData, "_blank");
    InterfaceAsesmenRalan.print(this.stateAsesmenAwal["id"]);
  }

  soap() {
    this.$emit("isiSoap");
  }
}
